import { IconCheck } from './IconCheck'

export default IconCheck
